import { toInsightLine } from "./insightActionPlanDefaults";

/** Protect existing markdown emphasis, code, and links from re-processing. */
const PROTECTED_SEGMENT_RE = /(\*\*[^*]+?\*\*|`[^`]+`|\[[^\]]+\]\([^)]+\))/g;

/**
 * Match metrics worth highlighting in insight narratives:
 * percentages, counts with units, large numbers, index scores, and time windows.
 */
const METRIC_RE =
  /(?:<|>|≤|≥)?\d+(?:,\d{3})*(?:\.\d+)?\s*%|\d+(?:,\d{3})*(?:\.\d+)?\s+(?:schools?|blocks?|students?|teachers?|days?|records?|cases?|units?|clusters?|villages?|districts?|UDISE(?:\s+codes?)?|schools?-wise)|\b\d{1,3}(?:,\d{3})+\b|\b\d{1,3}\.\d{1,2}\b|(?:within|top)\s+\d+(?:\s+days?)?|\b\d+\s*[–-]\s*\d+(?:\s+days?)?/gi;

const isProtectedSegment = (segment) =>
  /^\*\*[^*]+\*\*$/.test(segment) ||
  /^`[^`]+`$/.test(segment) ||
  /^\[[^\]]+\]\([^)]+\)$/.test(segment);

const collapseDuplicateBold = (text) =>
  String(text || "")
    .replace(/\*\*\*\*+/g, "**")
    .replace(/\*\*(\*\*([^*]+)\*\*)\*\*/g, "**$2**");

const emphasizePlainSegment = (text) => {
  if (!text) return "";

  return text.replace(METRIC_RE, (match, offset, source) => {
    const before = source.slice(Math.max(0, offset - 2), offset);
    const after = source.slice(offset + match.length, offset + match.length + 2);
    if (before.endsWith("*") || after.startsWith("*")) return match;
    return `**${match.trim()}**`;
  });
};

/**
 * Wrap numbers, percentages, and metric phrases in markdown bold for Intervention Action Plan.
 */
export const emphasizeInsightMetrics = (text) => {
  const input = String(text || "").trim();
  if (!input) return "";

  const emphasized = input
    .split(PROTECTED_SEGMENT_RE)
    .map((segment) => (isProtectedSegment(segment) ? segment : emphasizePlainSegment(segment)))
    .join("");

  return collapseDuplicateBold(emphasized);
};

export const emphasizeInsightList = (items = []) =>
  (Array.isArray(items) ? items : [])
    .map((item) => toInsightLine(item))
    .filter(Boolean)
    .map((item) => `- ${emphasizeInsightMetrics(item)}`)
    .join("\n");
